import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Title = styled.span`
    font-size: 28px;
    font-weight: 300;
    line-height: 36px;
`;

export const BodyContainer = styled.div`
    margin: 32px 0;
`;

const ErrorMessage = ({ title, children }) => {
    return (
        <Container>
            <Title>{title}</Title>
            <BodyContainer>{children}</BodyContainer>
        </Container>
    );
};

ErrorMessage.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.node,
};

export default ErrorMessage;
